import i18n, { TOptions } from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import { pl } from './resources/pl';

const formatCountForInterval = (count: number) => {
  if (count % 1 !== 0) {
    return 22;
  }
  if (count > 21) {
    const slicedCount = Number(count.toString().slice(-1));
    if (slicedCount === 1) {
      return count;
    }
    return slicedCount;
  }
  return count;
};

i18n
  .use(initReactI18next)
  .use({
    type: 'postProcessor',
    name: 'interval',
    process: (value: string, key: string[], options: TOptions, translator: any) => {
      let parsedOptions = options;
      if (options.lng === 'pl' && !parsedOptions.omitCountParsing) {
        const count = parsedOptions.count || 0;
        parsedOptions = {
          ...parsedOptions,
          count: formatCountForInterval(count),
        };
      }
      return intervalPlural.process(value, key, parsedOptions, translator);
    },
  })
  .init({
    lng: 'pl',
    interpolation: {
      defaultVariables: { specialChar: '' },
    },
    resources: {
      pl,
    },
  });

export default i18n;
